import React from 'react';

import FaceBookLogo from 'images/FB-f-Logo__blue_50.png';
import LinkedInLogo from 'images/In-2C-41px-TM.png';
import TwitterLogo from 'images/Twitter_Social_Icon_Circle_Color.png';

import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

interface EmployeeCardProps {
  name: string;
  title: string;
  bio: string;
  facebookUrl?: string;
  linkedinUrl?: string;
  twitter?: string;
  recentArticle?: string;
  canSendMessage?: boolean;
  onMessage?: () => void;
}

export default function EmployeeCard({
  name,
  title,
  bio,
  facebookUrl,
  linkedinUrl,
  twitter,
  recentArticle,
  canSendMessage,
  onMessage,
}: EmployeeCardProps) {
  return (
    <div className="EmployeeCard w-full">
      <Accordion square={false}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography className="header">{name}</Typography>
          <Typography className="title">{title}</Typography>
        </AccordionSummary>
        <AccordionDetails className="panel-detail">
          <div className="bio">{bio}</div>
          <div className="social-links">
            {facebookUrl && (
              <div className="container facebook">
                <a href={facebookUrl}>
                  <img src={FaceBookLogo}></img>
                </a>
              </div>
            )}
            {linkedinUrl && (
              <div className="container linked-in">
                <a href={linkedinUrl}>
                  <img src={LinkedInLogo}></img>
                </a>
              </div>
            )}
            {twitter && (
              <div className="container twitter">
                <a href={`https://twitter.com/${twitter}`}>
                  <img src={TwitterLogo}></img>
                </a>
              </div>
            )}
          </div>
          {canSendMessage && (
            <div className="message-button">
              <button className="button button-red" onClick={onMessage} data-test="message-button">
                Message
              </button>
            </div>
          )}
          {recentArticle && (
            <div className="recent-articles-links">
              <a
                href={recentArticle}
                className="button button-dark"
                data-test="view-recent-articles-button"
              >
                View Recent Articles
              </a>
            </div>
          )}
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
